import React from 'react';
import '../styles/App.css'; 

const Welcome = () => {
  return (
    <section className="welcome-section">
      <div className="container">
        <div className="welcome-grid">
          <div className="welcome-content">
            <div className="welcome-header">
              <h2>Welcome to Talali Lodge</h2>
              <div className="welcome-divider"></div>
            </div>
            <p className="welcome-intro">
              Talali Lodge is a comfortable and welcoming accommodation facility located in Area 9, 
              Lilongwe, along Area 9 Mosque Street. The lodge offers a peaceful environment ideal for 
              both business and leisure travelers seeking comfort, convenience, and quality service.
            </p>
            <p className="welcome-description">
              With well-maintained rooms and professional conference facilities, Talali Lodge is a 
              perfect choice for guests visiting Lilongwe.
            </p>
            
            <div className="location-details">
              <h3><span className="location-icon">📍</span> Our Location</h3>
              <ul className="location-list">
                <li><strong>Address:</strong> Area 9, Mosque Street, Lilongwe</li>
                <li><strong>Postal:</strong> P.O. Box 1912, Lilongwe</li>
              </ul>
              <p className="location-note">
                Talali Lodge enjoys a strategic location with easy access to major business areas, 
                government institutions, shopping centers, and places of worship.
              </p>
            </div>
          </div>
          
          <div className="welcome-image-container">
            <div className="image-wrapper">
              <img 
                src="/images/welcome/welcome-image.jpg" 
                alt="Talali Lodge - Comfortable Accommodation in Lilongwe" 
                className="welcome-image"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = `
                    <div class="image-fallback">
                      <h3>Strategic Location</h3>
                      <p>Easy access to business districts, shopping, and government offices</p>
                    </div>
                  `;
                }}
              />
              <div className="image-overlay">
                <div className="overlay-content">
                  <h3>Prime Location</h3>
                  <p>In the heart of Lilongwe's business district</p>
                </div>
              </div>
            </div>
            <div className="image-caption">
              <p><span className="caption-icon">⭐</span> Conveniently located in Area 9, close to major amenities</p>
            </div>
          </div>
        </div>
        
        {/* Features Grid */}
        <div className="features-highlights">
          <h3 className="features-title">Why Stay With Us</h3>
          <div className="welcome-features-grid">
            <div className="feature-highlight">
              <span className="feature-icon">🏨</span>
              <h4>14 Rooms</h4>
              <p>Comfortable accommodation options for every traveler</p>
            </div>
            <div className="feature-highlight">
              <span className="feature-icon">🤝</span>
              <h4>Friendly Staff</h4>
              <p>Professional and welcoming team ready to assist you</p>
            </div>
            <div className="feature-highlight">
              <span className="feature-icon">📍</span>
              <h4>Central Location</h4>
              <p>Easy access to business and leisure destinations</p>
            </div>
            <div className="feature-highlight">
              <span className="feature-icon">🛡️</span>
              <h4>Secure Environment</h4>
              <p>24/7 security for your peace of mind</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome;